export const lightTheme = {
  // keep it as is
};

export const darkTheme = {
  body: "#000000",
  text: "#FAFAFA",
  toggleBorder: "#6B8096",
  gradient: "linear-gradient(#091236, #1E215D)",
  link: "#007bff",
};
